/**
 * @generated SignedSource<<d54297b2d2ef6f6a77024948b4be91cc>>
 * @relayHash 91c86a09e6be17d446d9e528fd5b91ad
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 91c86a09e6be17d446d9e528fd5b91ad

import { ConcreteRequest } from 'relay-runtime';
export type useChFollowUpSickLeaveQuery$variables = {
  progressNoteIds: ReadonlyArray<string>;
  sickLeaveId?: string | null;
};
export type useChFollowUpSickLeaveQuery$data = {
  readonly ch_sickLeavesForFollowUp: {
    readonly isSuccess?: boolean;
    readonly result?: ReadonlyArray<{
      readonly employerName: string;
      readonly from: any;
      readonly id: string;
      readonly to: any;
    }>;
  };
};
export type useChFollowUpSickLeaveQuery = {
  response: useChFollowUpSickLeaveQuery$data;
  variables: useChFollowUpSickLeaveQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "progressNoteIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sickLeaveId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "progressNoteIds",
    "variableName": "progressNoteIds"
  },
  {
    "kind": "Variable",
    "name": "sickLeaveId",
    "variableName": "sickLeaveId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSuccess",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_SickLeave",
      "kind": "LinkedField",
      "name": "result",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "from",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "to",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employerName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SuccessSickLeavesForFollowUpResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChFollowUpSickLeaveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "ch_sickLeavesForFollowUp",
        "plural": false,
        "selections": [
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChFollowUpSickLeaveQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "ch_sickLeavesForFollowUp",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "91c86a09e6be17d446d9e528fd5b91ad",
    "metadata": {},
    "name": "useChFollowUpSickLeaveQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8373adc18cc6c623bb906604d353c413";

export default node;
